import { UntitledLoading } from '@payaca/ambrosia';
import { FC } from 'react';

import useGetDocumentTemplate from '@/api/queries/me/useGetDocumentTemplate';

import { useHistory, useLocation } from 'react-router';
import { CreateEditDocumentTemplateForm } from '../components/createEditDocumentTemplate/CreateEditDocumentTemplateForm';
import AuthenticatedPageWrapper from './pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';

export const CreateEditDocumentTemplatePage: FC<{
  templateId?: string;
}> = (props) => {
  const { templateId } = props;
  const history = useHistory();

  const { documentTemplate, isLoading } = useGetDocumentTemplate(templateId);

  if (templateId && !documentTemplate && !isLoading) {
    // The provided templateId does not correspond to a valid template.
    // Navigate back.
    history.goBack();
  }

  return (
    <>
      <AuthenticatedPageWrapper
        scrollLock
        breadcrumbItems={[
          { label: 'Back', to: '/templates/document-templates' },
          { label: 'Document Template' },
        ]}
      >
        {isLoading && (
          <div className="w-full h-full flex items-center justify-center">
            {/* TODO MH better styles here */}
            <UntitledLoading />
          </div>
        )}
        {!isLoading && (
          <CreateEditDocumentTemplateForm
            template={documentTemplate}
            onSuccess={() => history.push('/templates/document-templates')}
          />
        )}
      </AuthenticatedPageWrapper>
    </>
  );
};
